// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
export class URL {
  public static readonly FIND_INVOICE = "https://whmcs-base.haulmer.dev/includes/api/findInvoices.php";
  public static readonly RACKEO_LOGIN = 'https://panel.rackeo.host/clientarea.php';
  public static readonly RACKEO_WEBSITE = 'https://www.rackeo.com.ar';
  public static readonly RACKEO_PAYMENT_WEBSITE = 'https://www.rackeo.cl';
  public static readonly RACKEO_LOCALE = 'es-AR';
  public static readonly RACKEO_OG_LOCALE = 'es_AR';
  public static readonly RACKEO_DOCS = 'https://help.haulmer.com/hc/';
  public static readonly RACKEO_YOUTUBE = 'https://www.youtube.com/watch?v=4a_6wk3S07w&list=PLjrWznOBcdHVUbW5iYup_GU_n7klz4ITm&index=2';
  public static readonly RACKEO_STATUS = 'https://status.rackeo.host';
  public static readonly RACKEO_INVOICE_REQUEST = 'https://haulmer.atlassian.net/servicedesk/customer/portal/1014/group/1050/create/1256';
  public static readonly SUPPORT = 'https://haulmer.atlassian.net/servicedesk/customer/portal/1014';
  public static readonly SUPPORT_CHAT = 'https://haulmer.atlassian.net/servicedesk/customer/portal/1014';
  public static readonly SUPPORT_SUGGESTIONS = 'https://haulmer.atlassian.net/servicedesk/customer/portal/1014/group/1050/create/1257';
  public static readonly HAULMER_BLOG = 'https://www.haulmer.com/blog/';
  public static readonly HAULMER_LEGAL_UPTIME_SLA = 'https://www.haulmer.com/legal/garantia-de-uptime-y-sla/';
  public static readonly HAULMER_LEGAL_REFUND = 'https://www.haulmer.com/legal/garantia-de-reembolso/';
  public static readonly HAULMER_LEGAL_WEB_HOSTING = 'https://www.haulmer.com/legal/tag/web-hosting/';
  public static readonly RACKEO_CART = 'https://panel.rackeo.host/cart.php';
}

export class TOKENS {
  public static readonly RECAPTCHA = '6LcZVcQnAAAAAPK07G4Df3ZMAIrguKzgosDCNw6m';
  public static readonly SLAASK_CHAT_KEY = 'spk-0728b4d9-ad02-49b3-8ff1-dcd3beba78f3';
}
